import * as d3 from "d3";
import { group as d3Group } from "d3-array";
import { DataDRequest } from "../../data/DRequest";
import { Entidad } from "../../data/Entidad";
import { DataModuloMain } from "../../data/ModuloMain";
import { IFinanzaPagoRecibidoDetalle } from "../../data/entidad/FinanzaIngresoPagoRecibido";
import { MFinanzaIngresoPagoRecibido } from "../../data/model/MFinanzaIngresoPagoRecibido";
import { _DICC_ALUMNO, _DICC_ALUMNO_FULL } from "../../data/modulo/Alumno";
import { _DICC_AGRUPADORES_FULL, _SvFinanzasObtenerListaAgrupadorCargos, _SvFinanzasObtenerListaAgrupadorCargosByIds } from "../../data/modulo/FinanzaAgrupadorCargos";
import { _SvFinanzasObtenerPagosRecibidos } from "../../data/modulo/FinanzasPagosRecibidos";
import { ArrayV2 } from "../../util/ArrayV2";
import { DateV2 } from "../../util/DateV2";
import _L from "../../util/Labels";
import { IConfigGridExcelExport, IGridExtraTableConfig, IGridRenderInfo, VentanaGrid } from "../controlD3/AVentanaGrid";
import { ElementWrapper } from "../controlD3/ElementWrapper";
import { IExcelExportSheetConfig } from "../controlD3/ExcelThings/Export/Export";
import { SelectV2 } from "../controlD3/SelectV2";
import { Table } from "../controlD3/Tabla";
import { ReadonlyTableNode } from "../controlD3/Tabla/models/TableNode";
import { HTMLTooltipComponent } from "../controlWC/TooltipComponent";
import { UIUtilFormat } from "../util/Format";
import { UIUtilGeneral } from "../util/Util";
import { UIUtilViewData } from "../util/ViewData";
import { UIUtilViewFinanzaCargo } from "../utilView/FinanzasIngresos/FinanzaCargo";
import { UIUtilViewFinanzasIngresoUtil } from "../utilView/FinanzasIngresos/FinanzasIngresoUtil";
import { _GenerarResumenPDFModal } from "../utilView/FinanzasPagosRecibidos/GenerarResumenPDFModal";
import { CFinanzasTabs } from "./AlumnosPanelV2";

import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;

type IItemComboYear = UIUtilViewFinanzasIngresoUtil.IItemComboYear;
type IItemComboMonth = UIUtilViewFinanzasIngresoUtil.IItemComboMonth;

export class UIVentanaFinanzasPagosRecibidosV2 extends VentanaGrid<MFinanzaIngresoPagoRecibido> {
    private comboYear: SelectV2<IItemComboYear, "Id", "multiselect">;
    private comboMonth: SelectV2<IItemComboMonth, "Id", "multiselect">;
    private bolIncluyeExAlumnos: boolean = false;
    private dataPagosBySchool: Map<number, MFinanzaIngresoPagoRecibido[]>;

    private forceDownloadData: boolean;

    constructor(content: d3.Selection<HTMLDivElement, any, HTMLElement, any>, modulo: Entidad.CModulo) {
        super(content, modulo);
    }

    protected GridInitTable() {
        this.dataPagosBySchool = new Map();

        super.GridInitTable();
        this.AjustaDrawGrid();
        this.forceDownloadData = true;
    }

    private AjustaDrawGrid() {
        // Area combos-filtros
        let filterCont = this.ctrlTabla._Control.select(".filter_container");
        let searchwrapper = filterCont.select(".search-wrapper");

        let areaCombos = filterCont.append("div")
            .attr("class", UIUtilGeneral.FBoxOrientation.Horizontal)
            .style("column-gap", "calc(var(--padding2) * 4)")
            .style("padding", "0 var(--padding3) var(--padding2)")
            .style("box-sizing", "border-box")

        this.comboYear = (() => {
            const select = new SelectV2<IItemComboYear, "Id", "multiselect">({
                Parent: areaCombos,
                Type: "multiselect",
                ValueMember: "Id",
                DisplayMember: "Name",
                ListWidth: "200px",
                Data: () => UIUtilViewFinanzasIngresoUtil._ObtenerAniosDisponibles(this.kinders),
                OnChange: () => {
                    const monthsA = [...this.comboMonth._dataitems.map(d => d.Id)]
                    this.comboMonth._RefreshList()
                    if (this.comboMonth._dataSelected.length == 0) {
                        this.comboMonth._SelectAll(true)
                    } else {
                        const monthsB = [...this.comboMonth._dataitems.map(d => d.Id)]
                        const monthsSelect: string[] = []
                        for (const mB of monthsB) {
                            if (monthsA.includes(mB)) {
                                continue
                            }
                            monthsSelect.push(mB)
                        }
                        this.comboMonth._valueSelect(this.comboMonth._dataValueMemberSelected.concat(...monthsSelect))
                    }
                    this.forceDownloadData = false
                    this.GridUpdateData()
                }
            })
            areaCombos.append(() => {
                return ElementWrapper._WrapperToSelectControl(select, _L("time.anio") + ":")
                    .style("height", "35px")
                    .node();
            })
            return select
        })();
        this.comboMonth = (() => {
            const select = new SelectV2<IItemComboMonth, "Id", "multiselect">({
                Type: "multiselect",
                Parent: areaCombos,
                ValueMember: "Id",
                DisplayMember: "Name",
                ListWidth: "200px",
                Data: () => {
                    const idYears = this.comboYear._dataValueMemberSelected
                    return UIUtilViewFinanzasIngresoUtil._ObtenerMesesDisponibles(idYears)
                },
                OnChange: () => {
                    this.forceDownloadData = false
                    this.GridUpdateData()
                }
            })
            areaCombos.append(() => {
                return ElementWrapper._WrapperToSelectControl(select, _L("time.mes") + ":").node();
            })
            return select
        })();
        (() => {
            const tooltip: HTMLTooltipComponent = document.createElement("wc-tooltip") as HTMLTooltipComponent
            const input = document.createElement("input")
            input.type = "checkbox"
            input.id = "incluir_alumnos"
            input.onchange = () => {
                this.ctrlProgressBar.node()._Visible = true
                this.bolIncluyeExAlumnos = input.checked
                this.GridUpdateData()
                if (this.bolIncluyeExAlumnos)
                    tooltip.textContent = _L("finanzaspagosrecibidos.noincluir_exalumnos_desc")
                else
                    tooltip.textContent = _L("finanzaspagosrecibidos.incluir_exalumnos_desc")
            }
            tooltip.textContent = _L("finanzaspagosrecibidos.incluir_exalumnos_desc")
            areaCombos.append(() => {
                const wrapper = ElementWrapper._WrapperToElement(input, _L("finanzaspagosrecibidos.incluir_exalumnos"), {
                    LabelMaxWidth: "100%",
                    HideSeparator: true,
                }).node()
                wrapper.style.flex = "1"
                input.style.cursor = "pointer"
                wrapper.appendChild(tooltip)
                return wrapper
            })
        })();

        searchwrapper.raise()

        this.ctrlTabla._Control.select(".space_pie")
            .classed("hide", false)
            .style("display", "flex")
            .style("justify-content", "end")
            .text(_L("finanzaspagosrecibidos.tag_totalpagado") + ": " + UIUtilFormat._CurrencyFmt(0));

        // INIT VALUES
        this.comboYear._SelectAll(true)
        this.comboMonth._RefreshList()
        this.comboMonth._SelectAll(true)
        this.GridUpdateData()
    }

    private UpdateCurrentMonthTotal(data: ReadonlyTableNode<MFinanzaIngresoPagoRecibido>[]) {
        const total = this.CalculateTotalFromTableNode(data);
        this.ctrlTabla._Control
            .select(".space_pie")
            .text(_L("finanzaspagosrecibidos.tag_totalpagado") + ": " + UIUtilFormat._CurrencyFmt(total));
    }

    public _OnServiceEvent(requestID: DataModuloMain.TipoRequestMonitorId) {
        super._OnServiceEvent(requestID);
        if (requestID == Entidad.CTipoRequest.Alumno) {
            // this.UpdateGridData(true);
            this.forceDownloadData = false;
            this.GridUpdateData();
        }
    }

    // ***********************************************************************
    // Modal Form
    // ***********************************************************************


    // ***********************************************************************
    // Table config
    // ***********************************************************************

    protected GRID_GetMenuTopGrid(): Table.ITableMenuTopDefaultOptionConfig[] {
        return [{
            Label: this.VB_GetUIStringModule("generarresumen_opc"),
            Callback: () => _GenerarResumenPDFModal(this.dataGrid),
            GetDetails: () => {
                let enable = this.dataGrid.length > 0; //this.ctrlTabla ? (this.ctrlTabla.prop_data.length > 0) : false;
                let description = enable ? "" : this.VB_GetUIStringModule("generarresumen_err1");
                return {
                    Enabled: enable,
                    Description: description
                }
            }
        }];
    }
    protected GRID_GetSelectionDataMenuV2(menuLocation: "row" | "top-selected", dataGridSelected: MFinanzaIngresoPagoRecibido[]): Table.ITableMenuDataSelectedOptionConfig<MFinanzaIngresoPagoRecibido>[] {
        return [{
            Label: this.VB_GetUIStringModule("generarresumen_opc"),
            Callback: (datos) => _GenerarResumenPDFModal(datos),
        }];
    }
    protected GRID_GetDataRequestID(): DataModuloMain.TipoRequestMonitorId {
        return null;
    }

    protected GRID_GetTableConfigBase(): IGridRenderInfo<MFinanzaIngresoPagoRecibido> {
        return {
            IdTabla: "FinanzasIngresos-PagosRecibidos",
            Title: "",
            DefaultSort: "NombreCompletoAlumno",
            ItemGrouperField: "IDFolio",
            IdData: "Id",
            MinWidth: 1700,
            Columns: [
                { Field: "IDFolio", Label: "Folio", MinWidth: "60px", Width: "5%" },
                { Field: "NombreCompletoAlumno", Label: "Alumn@", MinWidth: "100px", Width: "13%" },
                { Field: "ConceptoCargo", Label: "Concepto", MinWidth: "80px", Width: "13%" },
                { Field: "ValorCobrarTotalFmt", LabelLangKey: "d_field_valorcargo", Label: "Total de cargo", MinWidth: "80px", Width: "8%", OrderField: "ValorCobrarTotal" },
                { Field: "ValorDescuentoTotalFmt", LabelLangKey: "d_field_descuentototal", Label: "Total de descuento", MinWidth: "95px", Width: "8%", OrderField: "ValorDescuentoTotal" },
                { Field: "ValorCobroFaltanteTotalFmt", LabelLangKey: "d_field_valorfaltante", Label: "Total por cobrar", MinWidth: "80px", Width: "8%", OrderField: "ValorCobroFaltanteTotal" },
                { Field: "ValorPagoFmt", LabelLangKey: "d_field_valor", Label: "Pagado", MinWidth: "80px", Width: "8%", OrderField: "ValorPago", OrderTypeParse: Number },
                { Field: "MetodoPagoInfoCompleta", LabelLangKey: "d_field_metodopagonombre", Label: "Método pago", MinWidth: "100px", Width: "9%", OrderTypeParse: String },
                { Field: "FolioPagoEnLinea", LabelLangKey: "d_field_foliopago", Label: "Folio pago", MinWidth: "80px", Width: "9%", OrderTypeParse: String },
                { Field: "FechaPagoFmt", Label: "Fecha pago", MinWidth: "80px", Width: "9%", OrderField: "FechaPago", OrderTypeParse: Date },
                { Field: "FechaAplicacionCargoFmt", LabelLangKey: "d_field_fechaaplicacion", Label: "Fecha aplicación", MinWidth: "90px", Width: "8%", OrderField: "FechaAplicacionCargo", OrderTypeParse: Date },
                { Field: "FechaVencimientoCargoFmt", LabelLangKey: "d_field_fechavencimiento", Label: "Fecha vencimiento", MinWidth: "100px", Width: "8%", OrderField: "FechaVencimientoCargo", OrderTypeParse: Date },
                { Field: "StrEscuela", Label: "Escuela", MinWidth: "80px", Width: "9%" },
            ]
        }
    }

    protected GRID_GetTableConfigAdvanced(): IGridExtraTableConfig<MFinanzaIngresoPagoRecibido> {
        return {
            OnEndUpdateDataInView: (currentDataInTable, dataChecked) => {
                let pagos: ReadonlyTableNode<MFinanzaIngresoPagoRecibido>[] = [];
                currentDataInTable.forEach(dP => { pagos.push(dP); });
                dataChecked.forEach(dP => { pagos.push(dP); });
                this.UpdateCurrentMonthTotal(pagos);
            },
            EvaluatorAndSubLevelsBuild: <Table.IStepEvaluator<MFinanzaIngresoPagoRecibido, never, never>>{
                OnStepCellTable: (container, pago, field: (keyof MFinanzaIngresoPagoRecibido)) => {
                    switch (field) {
                        case "NombreCompletoAlumno":
                            if (_DICC_ALUMNO.has(pago.IdAlumno))
                                UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", pago.IdAlumno, pago.NombreCompletoAlumno);
                            else
                                container.text(pago.NombreCompletoAlumno)
                            break;
                        case "ConceptoCargo":
                            UIUtilViewFinanzaCargo._RenderCargoNombre({
                                Categoria: pago.Categoria as unknown as Entidad.CFinanzaCargoCategoria,
                                Nombre: pago.ConceptoCargo,
                                IdEscuela: pago.IdEscuela,
                                IdAgrupador: pago.IdAgrupador
                            }, container.node());
                            break;
                        case "MetodoPagoInfoCompleta":
                            pago._ConsultarYAsignarDetallesPagoEnLinea().then(() => {
                                const metodoPagoInfoCompleta = pago.MetodoPagoInfoCompleta;
                                if (metodoPagoInfoCompleta) {
                                    container.text(metodoPagoInfoCompleta);
                                }
                            });
                            break;
                        case "ValorDescuentoTotalFmt":
                            UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", pago.IdAlumno, pago.ValorDescuentoTotalFmt, null, CFinanzasTabs.EdoCuenta);
                            break;
                    }
                },
            }
        }
    }

    protected GRID_GetFilters(): Array<Table.IParametroFiltro<MFinanzaIngresoPagoRecibido>> {
        return [
            { Field: "IDFolio", Label: "ID" },
            { Field: "NombreCompletoAlumno", Label: "Nombre" },
            { Field: "AlumnoEstado", Label: "AlumnoEstado", Type: "select", Options: UIUtilViewData._GetList_EstadosMovimientos() },
            {
                Field: "ConceptoCargo", Label: "Concepto", Type: "select",
                Options: () => DataModuloMain._GetReqDataArrayByName("FinanzaCargo")
                    .map(d => ({ Id: d.Nombre, Name: d.Nombre }))
                    .concat(this.ctrlTabla._data.map(d => ({ Id: d.PadreCargo.Concepto, Name: d.PadreCargo.Concepto })))
                    .filter(d => (!!d.Name))
                    .sort((a, b) => d3.ascending(a.Name.toLowerCase(), b.Name.toLowerCase())),
            },
            { Field: "ValorCobrarTotal", LabelLangKey: "d_field_valorcargo", Label: "Total de cargo $", Type: "number" },
            { Field: "ValorDescuentoTotal", LabelLangKey: "d_field_descuentototal", Label: "Total de descuento $", Type: "number" },
            { Field: "ValorCobroFaltanteTotal", LabelLangKey: "d_field_valorfaltante", Label: "Total por cobrar $", Type: "number" },
            { Field: "ValorPago", LabelLangKey: "d_field_valor", Label: "Pagado $", Type: "number" },
            {
                Field: "MetodoPagoNombre", Label: "Método de pago", Type: "select",
                Options: () => DataModuloMain._GetReqDataArrayByName("FinanzaMetodoPago")
                    .map(d => ({ Id: d.Nombre, Name: d.Nombre }))
                    .sort((a, b) => d3.ascending(a.Name.toLowerCase(), b.Name.toLowerCase())),
            },
            { Field: "FolioPagoEnLinea", LabelLangKey: "d_field_foliopago", Label: "Folio de pago" },
            {
                Field: "FechaPago", LabelLangKey: "d_field_fecharegistro", Label: "Fecha pago", Type: "date-time",
                OnGetValueToMatch: (d) => ([
                    new DateV2(d.FechaPago)._SetTimeZoneByIdSchool(d.IdEscuela)
                ])
            },
            { Field: "FechaAplicacionCargo", LabelLangKey: "d_field_fechaaplicacion", Label: "Fecha aplicación", Type: "date" },
            { Field: "FechaVencimientoCargo", LabelLangKey: "d_field_fechavencimiento", Label: "Fecha vencimiento", Type: "date" }
        ]
    }

    protected GridOnSyncData() {
        this.forceDownloadData = true;
        return super.GridOnSyncData();
    }

    protected async GridGetData() {
        // FIXME
        // console.warn("GridGetData"); // FIXME Al crear la ventana, se repiten dos veces las peticiones. Origen > VentanaGrid, SelectControlAño
        // FIXME
        if (this.dataPagosBySchool.size == 0 || this.forceDownloadData) {
            const res = await this.GetPagosRecibidosList();
            let hasError: boolean
            res.forEach((d) => {
                if (!hasError && d.Resultado <= 0) {
                    hasError = true
                }
                if (d.Resultado > 0) {
                    this.dataPagosBySchool.set(d.Resultado, d.Datos)
                }
            })
            if (hasError) {
                this.notificacion._Mostrar(_L("general.notif_fail_infoupdate"), "ADVERTENCIA")
            }
        }
        const monthFilter = this.comboMonth._dataSelected
        const dataFilter: MFinanzaIngresoPagoRecibido[] = []

        this.dataPagosBySchool.forEach((pagosEscuela, idEscuela) => {
            pagosEscuela.forEach(p => {
                const dt = new DateV2(p.FechaPago)._SetTimeZoneByIdSchool(idEscuela)
                const isValid = monthFilter.some(f => (dt.getFullYear() == f.Year && dt.getMonth() == f.Month))
                if (isValid) {
                    dataFilter.push(p)
                }
            })
        })
        setTimeout(() => {
            this.ctrlTabla._MenuTopDefault._Refresh();
        });
        return dataFilter;
    }

    // ***********************************************************************
    // Get data
    // ***********************************************************************

    private CalculateTotalFromTableNode(datos: ReadonlyTableNode<MFinanzaIngresoPagoRecibido>[]): number {
        return datos.reduce<number>((total, itemTablePago) => (total + itemTablePago.data.ValorPago), 0)
    }

    private CalculateTotalFromDatum(datos: Pick<MFinanzaIngresoPagoRecibido, "ValorPago">[]): number {
        return datos.reduce<number>((total, d) => (total + d.ValorPago), 0)
    }

    // ***********************************************************************
    // Data final things
    // ***********************************************************************

    private async GetPagosRecibidosList(): Promise<DataDRequest.IRequestResponseA<MFinanzaIngresoPagoRecibido[]>[]> {
        const result: DataDRequest.IRequestResponseA<MFinanzaIngresoPagoRecibido[]>[] = [];
        const dictAlumnos = this.bolIncluyeExAlumnos ? _DICC_ALUMNO_FULL : _DICC_ALUMNO;

        for (let { IdKinder: idEscuela } of this.kinders) {
            const idsAgrupadoresFaltantes = new Set<number>();
            const pagosrecibidos: MFinanzaIngresoPagoRecibido[] = [];

            await _SvFinanzasObtenerListaAgrupadorCargos(idEscuela);
            const res = await _SvFinanzasObtenerPagosRecibidos(idEscuela);

            if (res.Resultado <= 0) {
                result.push(res as any)
                continue
            }
            for (const cargoPago of res.Datos) {
                const alumno: Entidad.IAlumno = dictAlumnos.get(cargoPago.IdAlumno)
                if (!alumno) continue

                const categoriasPago = [CCategoriaMov.PagoCompleto, CCategoriaMov.PagoParcial]
                const pagosRealizados: IFinanzaPagoRecibidoDetalle[] = cargoPago.Detalles.filter(d => categoriasPago.includes(d.Categoria))

                for (const movimientoPago of pagosRealizados) {
                    const pagoRecibido = new MFinanzaIngresoPagoRecibido(movimientoPago, cargoPago, idEscuela);
                    pagosrecibidos.push(pagoRecibido);
                }

                if (cargoPago.IdAgrupador > 0 && !_DICC_AGRUPADORES_FULL.get(idEscuela)?.has(cargoPago.IdAgrupador)) {
                    idsAgrupadoresFaltantes.add(cargoPago.IdAgrupador)
                }
            }

            if (idsAgrupadoresFaltantes.size > 0) {
                await _SvFinanzasObtenerListaAgrupadorCargosByIds(idEscuela, Array.from(idsAgrupadoresFaltantes))
            }

            result.push({
                Resultado: idEscuela,
                Datos: pagosrecibidos
            })
        }

        return result
    }

    protected GRID_GetExportarConfig(dataGrid: MFinanzaIngresoPagoRecibido[]): IConfigGridExcelExport<MFinanzaIngresoPagoRecibido> {

        const groupedData: Map<number, MFinanzaIngresoPagoRecibido[]> = d3Group(dataGrid, d => d.IdEscuela);
        const idsEscuelas: number[] = [...groupedData.keys()];

        setTimeout(() => this.ctrlProgressBarExport?._MostrarMensajeCentrado(_L("general.loading")), 200);
        setTimeout(() => this.ctrlProgressBarExport?._MostrarMensajeCentrado(_L("general.proceso_espera_minutos")), 2200);

        // Mostrar notificación de error de consulta de detalles solo la primera vez que ocurra
        let hasError = false
        const errorNotification = () => {
            if (!hasError) {
                this.notificacion._Mostrar(_L("general.notif_fail_infosync"), "ADVERTENCIA")
                hasError = true
            }
        }

        return {
            IdsEscuelas: idsEscuelas,
            ColumnsConfig: [
                { Field: "IDFolio", HeaderTag: _L("finanzaspagosrecibidos.d_field_idfolio"), WidthCell: 25 },
                { Field: "NombreCompletoAlumno", HeaderTag: _L("finanzaspagosrecibidos.d_field_nombrecompletoalumno"), WidthCell: 35 },
                { Field: "ConceptoCargo", HeaderTag: _L("finanzaspagosrecibidos.d_field_conceptocargo"), WidthCell: 25 },
                { Field: "ValorCobrarTotalFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_valorcargo"), WidthCell: 20 },
                { Field: "ValorDescuentoTotalFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_descuentototal"), WidthCell: 20 },
                { Field: "ValorCobroFaltanteTotalFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_valorfaltante"), WidthCell: 20 },
                { Field: "ValorPagoFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_valor"), WidthCell: 20 },
                { Field: "MetodoPagoNombre", HeaderTag: _L("finanzaspagosrecibidos.d_field_metodopagonombre"), WidthCell: 30 },
                { Field: "MetodoPagoDetalle", HeaderTag: _L("finanzaspagosrecibidos.d_field_metodopagodetalle"), WidthCell: 30 },
                { Field: "FolioPagoEnLinea", HeaderTag: _L("finanzaspagosrecibidos.d_field_foliopago"), WidthCell: 25 },
                { Field: "FechaPagoFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_fecharegistro"), WidthCell: 25 },
                { Field: "FechaAplicacionCargoFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_fechaaplicacion"), WidthCell: 25 },
                { Field: "FechaVencimientoCargoFmt", HeaderTag: _L("finanzaspagosrecibidos.d_field_fechavencimiento"), WidthCell: 25 },
            ],
            OnGetDataBySheets: async () => {
                return new ArrayV2<[number, MFinanzaIngresoPagoRecibido[]]>()
                    ._Push(...Array.from(groupedData))
                    ._MapAwait(async ([idEscuela, datosEscuela]) => {
                        for (const d of datosEscuela) {
                            await d._ConsultarYAsignarDetallesPagoEnLinea()
                                .then((res) => {
                                    if (res?.IdFolio <= 0) {
                                        errorNotification();
                                    }
                                    return UIUtilGeneral._Sleep(50); // evitar sobrecarga de consultas
                                })
                        }
                        return <IExcelExportSheetConfig<MFinanzaIngresoPagoRecibido>>{
                            IdSheet: idEscuela,
                            SheetName: datosEscuela[0].StrEscuela,
                            Data: datosEscuela,
                            ExtraPie: [{
                                Label: _L("finanzaspagosrecibidos.tag_totalpagado"),
                                Value: UIUtilFormat._CurrencyFmt(this.CalculateTotalFromDatum(datosEscuela)),
                                Alignment: "right"
                            }]
                        }
                    })
            },
            OnGetEscuelasTagInSheet: (datos) => datos[0].StrEscuela
        }
    }
}